exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".value[data-v-5eaaed07]{font-weight:700;font-size:24px}", ""]);

// exports
